import {ApiCollection} from "./api.collection";
import {State} from "../models/state.model";


export const States = ApiCollection.extend({
    model: State,
    comparator: 'name',
    url: 'api/states',
});
